// VX: bundle "Elige un Pack y Ahorra". Talla por unidad, "Elegir" otro modelo y añadir el pack completo al carrito.
if (!customElements.get('vx-bundle')) {
  customElements.define(
    'vx-bundle',
    class VxBundle extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        try {
          this.data = JSON.parse(this.querySelector('[data-vx-bundle-data]').textContent);
        } catch (e) {
          return;
        }
        this.byHandle = {};
        this.data.products.forEach((p) => (this.byHandle[p.handle] = p));
        this.current = this.byHandle[this.data.current];
        this.moneyFormat = this.dataset.money || '${{amount}}';
        this.opts = Array.from(this.querySelectorAll('.vx-bundle__opt'));
        this.units = [{ handle: this.data.current, variantId: Number(this.dataset.currentVariant) }];
        this.pickerFor = null;

        this.opts.forEach((opt) => {
          opt.addEventListener('click', (e) => {
            if (e.target.closest('select, button, .vx-bundle__units')) return;
            this.select(Number(opt.dataset.index));
          });
          opt.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.select(Number(opt.dataset.index));
            }
          });
        });

        const def = Number(this.dataset.default) || 1;
        this.select(this.opts.some((o) => Number(o.dataset.index) === def) ? def : Number(this.opts[0].dataset.index));
        this.startTimer();
        this.hookAddToCart();
        this.followVariantPicker();
      }

      // La 1ª unidad del pack sigue el color/talla elegidos en el selector de arriba
      followVariantPicker() {
        if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS) return;
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const v = event.data && event.data.variant;
          if (!v || event.data.sectionId !== this.dataset.section || !this.isConnected) return;
          if (!this.current || !this.current.variants.some((x) => x.id === v.id)) return;
          this.units[0] = { handle: this.data.current, variantId: v.id };
          this.renderUnits();
          this.updatePrices();
        });
      }

      money(cents) {
        const n = (cents / 100).toFixed(2);
        return this.moneyFormat
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
          .replace(/\{\{\s*amount\s*\}\}/, n);
      }

      variantOf(unit) {
        const p = this.byHandle[unit.handle];
        return p ? p.variants.find((v) => v.id === unit.variantId) : null;
      }

      firstAvailable(p) {
        return p.variants.find((v) => v.available) || p.variants[0];
      }

      select(index) {
        this.selected = this.opts.find((o) => Number(o.dataset.index) === index);
        const qty = Number(this.selected.dataset.qty);
        while (this.units.length < qty) this.units.push(null);
        this.opts.forEach((o) => {
          const on = o === this.selected;
          o.classList.toggle('is-selected', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
          o.querySelector('[data-units]').innerHTML = '';
        });
        this.renderUnits();
        this.updatePrices();
      }

      renderUnits() {
        const box = this.selected.querySelector('[data-units]');
        const qty = Number(this.selected.dataset.qty);
        box.innerHTML = '';
        for (let i = 0; i < qty; i++) {
          const unit = this.units[i];
          const row = document.createElement('div');
          row.className = 'vx-bundle__unit';
          if (unit) {
            const p = this.byHandle[unit.handle];
            const img = document.createElement('img');
            img.className = 'vx-bundle__unit-img';
            img.src = p.image || '';
            img.alt = '';
            img.width = 60;
            img.height = 75;
            const col = document.createElement('div');
            col.className = 'vx-bundle__unit-info';
            const title = document.createElement('p');
            title.className = 'vx-bundle__unit-title';
            title.textContent = p.title;
            col.appendChild(title);
            const controls = document.createElement('div');
            controls.className = 'vx-bundle__unit-controls';
            if (p.variants.length > 1) {
              const sel = document.createElement('select');
              sel.className = 'vx-bundle__select';
              sel.setAttribute('aria-label', 'Talla ' + (i + 1));
              p.variants.forEach((v) => {
                const o = document.createElement('option');
                o.value = v.id;
                o.textContent = v.title + (v.available ? '' : ' (agotado)');
                o.disabled = !v.available;
                if (v.id === unit.variantId) o.selected = true;
                sel.appendChild(o);
              });
              sel.addEventListener('change', () => {
                unit.variantId = Number(sel.value);
                this.updatePrices();
              });
              controls.appendChild(sel);
            }
            if (i > 0) {
              const ch = document.createElement('button');
              ch.type = 'button';
              ch.className = 'vx-bundle__choose';
              ch.textContent = this.dataset.choose || 'Elegir';
              ch.addEventListener('click', () => this.openPicker(i));
              controls.appendChild(ch);
            }
            col.appendChild(controls);
            row.appendChild(img);
            row.appendChild(col);
          } else {
            const plus = document.createElement('button');
            plus.type = 'button';
            plus.className = 'vx-bundle__plus';
            plus.setAttribute('aria-label', (this.dataset.choose || 'Elegir') + ' ' + (i + 1));
            plus.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#121212"/><path d="M12 7v10M7 12h10" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/></svg>';
            plus.addEventListener('click', () => this.openPicker(i));
            const ch = document.createElement('button');
            ch.type = 'button';
            ch.className = 'vx-bundle__choose';
            ch.textContent = this.dataset.choose || 'Elegir';
            ch.addEventListener('click', () => this.openPicker(i));
            row.classList.add('is-empty');
            row.appendChild(plus);
            row.appendChild(ch);
          }
          box.appendChild(row);
        }
      }

      openPicker(i) {
        this.pickerFor = i;
        const dlg = this.querySelector('[data-picker]');
        const grid = this.querySelector('[data-picker-grid]');
        grid.innerHTML = '';
        this.data.products.forEach((p) => {
          if (!p.variants.some((v) => v.available)) return;
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'vx-bundle-picker__item';
          b.innerHTML = '<img alt="" loading="lazy"><span></span>';
          b.querySelector('img').src = p.image || '';
          b.querySelector('span').textContent = p.title;
          b.addEventListener('click', () => {
            const prevVariant = this.units[0] ? this.variantOf(this.units[0]) : null;
            let v = this.firstAvailable(p);
            if (prevVariant) {
              const same = p.variants.find((x) => x.available && x.title === prevVariant.title);
              if (same) v = same;
            }
            this.units[this.pickerFor] = { handle: p.handle, variantId: v.id };
            dlg.close();
            this.renderUnits();
            this.updatePrices();
          });
          grid.appendChild(b);
        });
        dlg.showModal();
      }

      // Unidades que se añaden: los huecos sin elegir usan el mismo modelo y talla que la 1ª
      resolvedUnits() {
        const qty = Number(this.selected.dataset.qty);
        const out = [];
        for (let i = 0; i < qty; i++) {
          out.push(this.units[i] || { handle: this.units[0].handle, variantId: this.units[0].variantId });
        }
        return out;
      }

      updatePrices() {
        this.opts.forEach((o) => {
          const qty = Number(o.dataset.qty);
          const pct = Number(o.dataset.pct) || 0;
          // Igual que Shopify: el descuento se redondea por línea (misma variante = misma línea)
          const lines = {};
          for (let i = 0; i < qty; i++) {
            const u = (o === this.selected && this.units[i]) || this.units[0];
            const v = this.variantOf(u);
            if (!v) continue;
            lines[v.id] = (lines[v.id] || 0) + v.price;
          }
          let sum = 0;
          Object.keys(lines).forEach((id) => {
            const lineTotal = lines[id];
            sum += lineTotal - Math.round((lineTotal * pct) / 100);
          });
          o.querySelector('[data-price]').textContent = this.money(sum);
          // Precio de comparación tachado (solo existe si el bloque lo activa)
          const cmpEl = o.querySelector('[data-compare]');
          if (cmpEl) {
            let cmp = 0;
            for (let i = 0; i < qty; i++) {
              const v = this.variantOf((o === this.selected && this.units[i]) || this.units[0]);
              if (v) cmp += v.compare > v.price ? v.compare : v.price;
            }
            cmpEl.hidden = cmp <= sum;
            cmpEl.textContent = this.money(cmp);
          }
        });
      }

      startTimer() {
        const el = this.querySelector('.vx-bundle__timer');
        if (!el) return;
        const end = Number(el.dataset.end) * 1000;
        const out = el.querySelector('[data-vx-timer]');
        const pad = (n) => String(n).padStart(2, '0');
        // Cada día la oferta cambia a las 00:00 de Puerto Rico (UTC-4): se cuenta hasta esa medianoche
        // (o hasta el fin real si es antes) y el contador desaparece en el fin real.
        const pr = 4 * 3600000;
        const tick = () => {
          const now = Date.now();
          if (end - now <= 0) {
            el.hidden = true;
            clearInterval(t);
            return;
          }
          const nextMidnight = (Math.floor((now - pr) / 86400000) + 1) * 86400000 + pr;
          const d = Math.min(end, nextMidnight) - now;
          if (out) out.textContent = pad(Math.floor(d / 3600000)) + ':' + pad(Math.floor((d % 3600000) / 60000)) + ':' + pad(Math.floor((d % 60000) / 1000));
        };
        tick();
        const t = setInterval(tick, 1000);
      }

      hookAddToCart() {
        const section = this.closest('section') || document;
        const form = section.querySelector('product-form form[action*="/cart/add"]');
        if (!form) return;
        this.form = form;
        // Captura en el documento: se ejecuta ANTES que el envío normal de Dawn (que solo añadiría 1 unidad)
        document.addEventListener(
          'submit',
          (e) => {
            if (e.target !== this.form || !this.isConnected) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            this.addToCart();
          },
          true
        );
      }

      addToCart() {
        if (this.busy) return;
        const units = this.resolvedUnits();
        const counts = {};
        units.forEach((u) => (counts[u.variantId] = (counts[u.variantId] || 0) + 1));
        const items = Object.keys(counts).map((id) => ({ id: Number(id), quantity: counts[id] }));
        const btn = this.form.querySelector('button[name="add"]');
        const err = this.querySelector('[data-error]');
        err.hidden = true;
        this.busy = true;
        if (btn) {
          btn.classList.add('loading');
          btn.setAttribute('aria-disabled', 'true');
        }
        const drawer = document.querySelector('cart-drawer');
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.status) {
              err.textContent = data.description || data.message || 'No se pudo añadir al carrito.';
              err.hidden = false;
              return;
            }
            if (window.publish && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'vx-bundle', cartData: data });
            }
            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.classList.remove('is-empty');
              drawer.renderContents(data);
            } else {
              window.location.href = root + 'cart';
            }
          })
          .catch(() => {
            err.textContent = 'No se pudo añadir al carrito. Inténtalo de nuevo.';
            err.hidden = false;
          })
          .finally(() => {
            this.busy = false;
            if (btn) {
              btn.classList.remove('loading');
              btn.removeAttribute('aria-disabled');
            }
          });
      }
    }
  );
}
